import { render, staticRenderFns } from "./GivenOrder.vue?vue&type=template&id=33457f87&scoped=true&"
import script from "./GivenOrder.vue?vue&type=script&lang=js&"
export * from "./GivenOrder.vue?vue&type=script&lang=js&"
import style0 from "./GivenOrder.vue?vue&type=style&index=0&id=33457f87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33457f87",
  null
  
)

export default component.exports